export default __webpack_public_path__ + "static/media/overviewGif.689724e4.gif";